import React from "react";
import Header from "../header/HeaderFour";
import Banner from "../elements/BannerFour";
import Service from "../elements/ServiceFIve";
import WhatWeOffer from "../elements/whatweoffer";
import About from "../elements/AboutTwo";
import Service2 from "../elements/ServiceOne";
import SectorGrid from "../elements/Sector-grid";
import Counter from "../elements/Counter";
import Faq from "../elements/FaqThree";
import Contact from "../elements/ContactTwo";
import Footer from "../elements/Footer";





function HomeFour() {
  return (
    <div>
      <div className="index-Four">
        <Header />
        <main>
          <Banner />
          <Service />
          <WhatWeOffer />
          <About />
          <Service2 />
          <SectorGrid />
          <Counter />
          <Faq />
          <Contact />
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default HomeFour;
